<h2 mat-dialog-title>User Email</h2>

<mat-dialog-content>
  <div class="p-4">
    <form>
      <div class="mce-form-section space-y-4">
        <mat-form-field class="w-full">
          <mat-label>Email</mat-label>
          <input matInput
                 [formField]="form.email"
                 placeholder="Enter the user's email address" />

          @for (error of form.email().errors(); track error.kind ) {
          <mat-error>
            {{ error.message }}
          </mat-error>
          }
        </mat-form-field>

        <mat-checkbox [formField]="form.acknowledged"
                      required>
          I confirm that I have the necessary permissions to use this email address.
        </mat-checkbox>
      </div>
    </form>
  </div>
</mat-dialog-content>

<div mat-dialog-actions>
  <div class="w-full">
    <mce-save-cancel [config]="saveCancelConfig()"
                     (action)="onSaveCancelAction($event)">
    </mce-save-cancel>
  </div>
</div>
